module.exports = __webpack_public_path__ + "img/arrow-left-thick.186e9460.svg";